import classNames from 'classnames';
import styled from 'styled-components';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandS, BrandXXS } from '@sorare/core/src/atoms/typography';
import { useAmountWithConversion } from '@sorare/core/src/hooks/useAmountWithConversion';
import { MonetaryAmount } from '@sorare/core/src/lib/monetaryAmount';

import { useConversionCreditForPrice } from '@sorare/marketplace/src/hooks/useConversionCreditForPrice';

const Root = styled(Vertical).attrs({ gap: 0 })`
  align-items: center;
  &.rightAligned {
    align-items: flex-end;
  }
`;
const PriceWithCredits = styled(BrandS)`
  color: var(--c-onBase-success);
  background: var(--c-gradient-discount);
  background-clip: text;
  -webkit-text-fill-color: transparent;
`;
const Price = styled(BrandXXS)`
  color: var(--c-nd-600);
  text-decoration: line-through;
`;

type Props = {
  price: MonetaryAmount;
  rightAligned?: boolean;
};
export const FirstLineupPlayerPrice = ({ price, rightAligned }: Props) => {
  const { priceDiscountedAmount } = useConversionCreditForPrice({
    price,
    sport: Sport.FOOTBALL,
  });
  const { main: mainDiscounted } = useAmountWithConversion({
    monetaryAmount: priceDiscountedAmount,
  });
  const { main } = useAmountWithConversion({
    monetaryAmount: price,
  });

  return (
    <Root gap={0} className={classNames({ rightAligned })}>
      <PriceWithCredits>{mainDiscounted}</PriceWithCredits>
      <Price>{main}</Price>
    </Root>
  );
};
